import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PriceDropStore {
  monitoredItems: Set<number>; // Set of item IDs being monitored
  addMonitor: (itemId: number) => void;
  removeMonitor: (itemId: number) => void;
  isMonitored: (itemId: number) => boolean;
  setMonitoredItems: (itemIds: number[]) => void;
}

type PriceDropStoreState = PriceDropStore & {
  monitoredItems: Set<number>;
};

export const usePriceDropStore = create<PriceDropStore>()(
  persist(
    (set, get) => ({
      monitoredItems: new Set<number>(),
      addMonitor: (itemId) =>
        set((state: PriceDropStoreState) => {
          const newSet = new Set(state.monitoredItems);
          newSet.add(itemId);
          return { monitoredItems: newSet };
        }),
      removeMonitor: (itemId) =>
        set((state: PriceDropStoreState) => {
          const newSet = new Set(state.monitoredItems);
          newSet.delete(itemId);
          return { monitoredItems: newSet };
        }),
      isMonitored: (itemId) => {
        return get().monitoredItems.has(itemId);
      },
      setMonitoredItems: (itemIds: number[]) =>
        set(() => ({
          monitoredItems: new Set(itemIds),
        })),
    }),
    {
      name: "price-drop-storage",
      merge: (persistedState, currentState) => {
        const persisted = persistedState as Partial<PriceDropStoreState> | undefined;
        const persistedItems = persisted?.monitoredItems;
        const monitoredItems = new Set(
          Array.isArray(persistedItems) ? persistedItems : Array.from(persistedItems || [])
        );
        return {
          ...currentState,
          ...persisted,
          monitoredItems,
        };
      },
      partialize: (state: PriceDropStoreState) => ({
        monitoredItems: Array.from(state.monitoredItems),
      }),
    }
  )
);
